// Centralized content for Anappuram Wooden Furniture Work.
// Swap the `image` URLs with the client's own photography before launch.

export const ICONS = {
  experience: (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 2v20M4 7l8-5 8 5M4 7v10l8 5 8-5V7"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  wood: (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
      <ellipse
        cx="12"
        cy="12"
        rx="9"
        ry="9"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M12 3c2 3 2 15 0 18M6 6c3 2 9 2 12 0M6 18c3-2 9-2 12 0"
        stroke="currentColor"
        strokeWidth="1.2"
      />
    </svg>
  ),
  design: (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
      <path
        d="M4 20l4.2-1.2L19 8a2 2 0 0 0 0-2.8l-.2-.2a2 2 0 0 0-2.8 0L5.2 15.8 4 20z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  ),
  delivery: (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
      <path
        d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <circle cx="7" cy="18" r="1.6" stroke="currentColor" strokeWidth="1.4" />
      <circle
        cx="17.5"
        cy="18"
        r="1.6"
        stroke="currentColor"
        strokeWidth="1.4"
      />
    </svg>
  ),
  bed: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M3 18v-6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6M3 18v2M21 18v2M3 12V7h6v5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  ),
  wardrobe: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect
        x="4"
        y="3"
        width="16"
        height="18"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path d="M12 3v18" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="9.5" cy="12" r="0.6" fill="currentColor" />
      <circle cx="14.5" cy="12" r="0.6" fill="currentColor" />
    </svg>
  ),
  table: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M3 8h18M5 8v12M19 8v12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M3 8l1.5-4h15L21 8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  ),
  tvunit: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect
        x="3"
        y="5"
        width="18"
        height="9"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M3 18h18M9 14l-1 4M15 14l1 4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  cabinet: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect
        x="4"
        y="4"
        width="16"
        height="16"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M4 12h16M9 4v16M9 8h1M9 16h1M15 8h1M15 16h1"
        stroke="currentColor"
        strokeWidth="1.3"
      />
    </svg>
  ),
  office: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M4 19V6h9v13M13 11h7v8M4 19h16"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  ),
  door: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect
        x="5"
        y="2"
        width="14"
        height="20"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <circle cx="14.5" cy="12" r="0.7" fill="currentColor" />
    </svg>
  ),
  custom: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 3l2.4 5.1 5.6.7-4 3.9 1 5.6L12 15.8l-5 2.5 1-5.6-4-3.9 5.6-.7z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
    </svg>
  ),
};

export const SERVICES = [
  {
    key: "wardrobes",
    icon: ICONS.wardrobe,
    title: "Wardrobes",
    image: "/assets/11.png",
    description:
      "Custom-fitted wardrobes with sliding or hinged shutters, built to your exact room dimensions.",
    features: [
      "Made-to-measure fitting",
      "Sliding or hinged shutters",
      "Internal shelving & drawers",
    ],
  },
  {
    key: "kitchen-units",
    icon: ICONS.cabinet,
    title: "Kitchen Units",
    image: "/assets/ku.png",
    description:
      "Modular and custom kitchen units planned around your space, your workflow and your budget.",
    features: [
      "Modular layout planning",
      "Soft-close hinges",
      "Moisture-resistant build",
    ],
  },
  {
    key: "tv-units",
    icon: ICONS.tvunit,
    title: "TV Units",
    image: "/assets/22.png",
    description:
      "Wall-mounted and floor TV units with concealed wiring, display shelving and storage.",
    features: [
      "Concealed wire management",
      "Open & closed storage",
      "Wall-mounted or floor units",
    ],
  },
  {
    key: "interior-panelling",
    icon: ICONS.design,
    title: "Interior Panel Works",
    image: "/assets/int.png", // swap for a real panelling photo
    description:
      "Wall panelling, ceilings, partitions and full interior woodwork that ties a room together.",
    features: [
      "Wall & ceiling panelling",
      "Partitions & pooja units",
      "Complete interior packages",
    ],
  },
  {
    key: "stairs",
    icon: ICONS.experience,
    title: "Wooden Stairs",
    image: "/assets/sta.png", // swap for a real stairs photo
    description:
      "Solid-wood staircases, railings and handrails, designed for strength, safety and style.",
    features: [
      "Solid timber treads",
      "Railings & handrails",
      "Custom staircase designs",
    ],
  },
  {
    key: "custom-furniture",
    icon: ICONS.custom,
    title: "All Customisation",
    image: "/assets/7.png",
    description:
      "If you can imagine it, we can build it. Every piece is customised to your size, style and finish.",
    features: [
      "One-on-one consultation",
      "Built to exact measurements",
      "Any wood & finish on request",
    ],
  },
  {
    key: "beds-dining",
    icon: ICONS.bed,
    title: "Beds, Dining & More",
    image: "/assets/din.png",
    description:
      "Beds, dining sets, study tables and every other wooden furniture piece your home needs.",
    features: [
      "Beds & bedroom sets",
      "Dining tables & chairs",
      "Study & office furniture",
    ],
  },
  {
    key: "doors-other",
    icon: ICONS.door,
    title: "Doors & Other Furniture",
    image: "/assets/doo.png",
    description:
      "Wooden doors, frames, and any other furniture work you need. Just ask, we take it on.",
    features: [
      "Doors & frames",
      "Repairs & polishing",
      "All other furniture work",
    ],
  },
];

export const ADDITIONAL_SERVICES = [
  {
    key: "furniture-repair",
    icon: ICONS.wood,
    title: "Furniture Repair",
    image: "/assets/16.png",
    description:
      "Structural repairs and joinery restoration for ageing or damaged wooden furniture.",
    features: [
      "Joint & frame restoration",
      "Termite damage repair",
      "Hardware replacement",
    ],
  },
  {
    key: "polishing",
    icon: ICONS.design,
    title: "Polishing",
    image: "/assets/17.png",
    description:
      "Melamine, PU, and traditional French polish finishes that renew and protect wood.",
    features: [
      "PU & melamine finishes",
      "Traditional French polish",
      "Colour-matched touch-ups",
    ],
  },
  {
    key: "wood-carving",
    icon: ICONS.custom,
    title: "Wood Carving",
    image: "/assets/18.png",
    description:
      "Hand-carved detailing on headboards, doors, and panels in traditional Kerala motifs.",
    features: [
      "Traditional Kerala motifs",
      "Hand-chiselled detailing",
      "Custom relief patterns",
    ],
  },
];

export const GALLERY_ITEMS = [
  {
    title: "Teak Dining Suite",
    category: "Dining",
    image: "/assets/3.png",
  },
  {
    title: "Walk-in Wardrobe",
    category: "Bedroom",
    image: "/assets/4.png",
  },
  {
    title: "Carved Bed Frame",
    category: "Bedroom",
    image: "/assets/5.png",
  },
  {
    title: "Modular Kitchen",
    category: "Kitchen",
    image: "/assets/6.png",
  },
  {
    title: "Executive Study Desk",
    category: "Office",
    image: "/assets/9.png",
  },
  {
    title: "Floating TV Console",
    category: "Living Room",
    image: "/assets/14.png",
  },
];

export const TESTIMONIALS = [
  {
    name: "Anitha Menon",
    location: "Palakkad",
    quote:
      "The wardrobe and bed they built for our new home fit perfectly and the finishing is beautiful. Genuinely skilled craftsmen.",
    image:
      "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=200&q=80",
  },
  {
    name: "Rajesh Kumar",
    location: "Coimbatore",
    quote:
      "We ordered a full dining set and TV unit. The wood quality and attention to detail was well above what we expected.",
    image:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=200&q=80",
  },
  {
    name: "Sara Thomas",
    location: "Palakkad",
    quote:
      "From the first consultation to installation, everything was on schedule. Our kitchen cabinets have held up beautifully.",
    image:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=200&q=80",
  },
];

export const REACH = {
  eyebrow: "Pan-India Orders",
  title: "From Palakkad to Every Corner of India",
  description:
    "Our workshop is in Kinassery, but our furniture isn't limited to Kerala. We take orders from all over the country and deliver them with the same care.",
};

export const PROCESS_STEPS = [
  {
    icon: ICONS.design,
    title: "Enquiry",
    description:
      "Call or WhatsApp us with your requirement, from anywhere in India.",
  },
  {
    icon: ICONS.custom,
    title: "Design",
    description:
      "We share drawings, measurements and wood samples for your approval.",
  },
  {
    icon: ICONS.wood,
    title: "Manufacturing",
    description:
      "Skilled craftsmen build every piece in our Palakkad workshop.",
  },
  {
    icon: ICONS.delivery,
    title: "Delivery",
    description:
      "Finished furniture is packed, delivered and fitted with care.",
  },
];
